import {
  DatabaseIcon as Database,
  FilesIcon as Files,
  CodeIcon as Code,
  BuildingsIcon as Buildings,
} from "@phosphor-icons/react";

/** Hero strip on /findings. Shows portfolio-level counts at a glance. */
export default function FindingsOverviewStrip({ overview }) {
  if (!overview) return null;
  const cards = [
    {
      label: "Engagements",
      value: overview.workspaces_with_data,
      caption: "Workspaces with metadata",
      icon: Buildings,
    },
    {
      label: "Files cataloged",
      value: overview.total_files.toLocaleString(),
      caption: `${overview.unique_file_names.toLocaleString()} unique names`,
      icon: Files,
    },
    {
      label: "Programs cataloged",
      value: overview.total_programs.toLocaleString(),
      caption: `${overview.unique_program_names.toLocaleString()} unique names`,
      icon: Code,
    },
    {
      label: "Knowledge surface",
      value: `${overview.unique_file_names + overview.unique_program_names}`,
      caption: "Unique objects observed",
      icon: Database,
    },
  ];
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8"
      data-testid="findings-overview"
    >
      {cards.map((c) => (
        <div key={c.label} className="ml-card p-5">
          <div className="flex items-center gap-1.5 ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] mb-2">
            <c.icon size={11} weight="bold" />
            {c.label}
          </div>
          <div className="text-3xl font-semibold tabular-nums">{c.value}</div>
          <div className="text-xs text-[var(--ml-text-secondary)] mt-1">{c.caption}</div>
        </div>
      ))}
    </div>
  );
}
